export default "/images/calendar-event.svg?14fdeadceb81f5232e28cf872a92818c";